<template lang="pug">
  v-navigation-drawer.toolbartab.pt-12(
    v-model='visible'
    app
    :mini-variant='expandStatus && $vuetify.breakpoint.mdOnly'
    :expand-on-hover='expandStatus && $vuetify.breakpoint.lgAndUp'
    :permanent='$vuetify.breakpoint.lgAndUp||$vuetify.breakpoint.mdOnly'
  )
    v-list(:class="marqueeStatus ? 'pt-8' : ''")
      v-list-item
        v-flex.d-flex.justify-center
          h3.white--text.mb-1
            b {{ $t('menu') }}
      v-divider(color='#ffffff')
      template(
        v-for='(link,i) in items', 
      )
        v-divider(v-if='i==15 && isShowSideExternalGame', color='#ffffff')
        v-list-item(
          v-if='checkNavItemCond(link, i)'
          :to='i === 0 ? { path:link.to }  : { name:link.pathName }'
          :key='i'
          v-show='link.imgWhite && !link.Isclosed'
          @click='goTo(link)'
        )
          v-list-item-icon
            v-img(:src='link.imgWhite', width='20')
          v-list-item-content
            v-list-item-title.white--text
              b {{ link.name }}
      v-list-item(@click='$refs.rule.open()')
        v-list-item-icon
          v-img(src='@/assets/nav/submenu/icon_submenu13.svg', width='20')
        v-list-item-content
          v-list-item-title.white--text
            b {{ $t('rules-regulation') }}
      v-divider(v-if='isShowSideExternalGame', color='#ffffff')
      v-list-item(@click='logout()')
        v-list-item-icon
          v-img(src='@/assets/nav/submenu/icon_submenu14.svg', width='20')
        v-list-item-content
          v-list-item-title.white--text
            b {{ $t('logout') }} 
      v-list-item
      v-list-item
      v-list-item
    dialog-rule-main(ref='rule')  

</template>
<script> 
import { 
  auth as apiAuth,
} from '@/apis' 
import DialogRuleMain from '@/components/Dialog/DialogRuleMain'   
import { ROUTE_LOGIN } from '@/const/route' 
import { SPECIAL_ROLE_GROUP } from '@/const/roleId'
export default {
  components : {
    DialogRuleMain
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    expandStatus: {
      type: Boolean,
      default: false
    },
    marqueeStatus : {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    visible: false
  }),
  computed : {
    isShowSideExternalGame () {
      return !this.$vuetify.breakpoint.lgAndUp 
    },
    userProfile () {
      return this.$store.getters['userProfile/GETTERS_ME']
    },
    userRoleId () {
      return ((this.userProfile || {}).role || {}).id
    },
  },  
  methods: {
    checkNavItemCond (item, index) {
      const isIndexDis = index !== 1 && index !== 2 && index !== 3 && index !== 4 && index !== 5
      const isStatusNavItem = (this.isShowSideExternalGame && !item.Isclosed)
      const isNotRoleUser = SPECIAL_ROLE_GROUP.includes(this.userRoleId)
      const isUserRoleDis = !item.onlyUser || !isNotRoleUser
      return (isIndexDis || isStatusNavItem) && isUserRoleDis
    },
    goTo (item) { 
      if(item.newtab) { 
        window.open(item.to, '_blank');

      } else {
        this.$router.push({ name:item.pathName }).catch(()=>{}); 
      }
      this.GAsidebar(item.name)
    },
    openSideBar () {
      this.$ga.event('Button', 'OpenSideBarMobile', 'SideBar','' ) 
      this.visible=!this.visible
    },
    GAsidebar (name){
      this.$ga.event('Button', 'SelectPage', 'SideBar',name )
    },

    async logout () {
      this.$confirm('',this.$t('confirm.logout'),'warning').then(async ()=>{ 
        window.removeEventListener('focus', this.checkCurrentGame);
        await apiAuth.logout() 
        this.$store.dispatch('auth/ACTION_LOGOUT') 
        this.$ga.event('Button', 'Logout', 'SideBar','' )
        this.$router.push({
          name:ROUTE_LOGIN
        }).catch(()=>{}); 
      }) 
    },
  }
}
</script>
<style scoped>
::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
} 
</style>